import { Link } from 'react-router-dom';
import { categories, siteInfo } from '@/mocks/movies';

export default function Footer() {
  return (
    <footer className="bg-foreground-950 text-background-100">
      <div className="px-4 md:px-6 py-12 md:py-14">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
            <div>
              <Link to="/" className="flex items-center gap-2.5 mb-4 cursor-pointer group">
                <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                  <i className="ri-movie-2-fill text-background-50 text-lg"></i>
                </div>
                <span className="text-xl font-heading font-bold text-background-50">
                  丫丫影院
                </span>
              </Link>
              <p className="text-sm text-foreground-400 leading-relaxed">
                {siteInfo.tagline}。无需付费注册，全集免费看，高清不缓冲在线观看。
              </p>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4">影视分类</h4>
              <div className="flex flex-col gap-2.5">
                {categories.map((cat) => (
                  <Link
                    key={cat.slug}
                    to={`/category/${cat.slug}`}
                    className="text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer"
                  >
                    <i className={`${cat.icon} mr-2`}></i>
                    {cat.name}
                  </Link>
                ))}
              </div>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4">快速链接</h4>
              <div className="flex flex-col gap-2.5">
                <Link to="/" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">首页</Link>
                <Link to="/about" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">关于我们</Link>
                <Link to="/category/tv" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">最新电视剧</Link>
                <Link to="/category/movie" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">热门电影</Link>
                <Link to="/category/anime" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">动漫推荐</Link>
              </div>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4">联系我们</h4>
              <div className="flex flex-col gap-2.5 text-sm text-foreground-400">
                <p><i className="ri-mail-line mr-2"></i>{siteInfo.email}</p>
                <p><i className="ri-wechat-line mr-2"></i>yayacinema</p>
                <p><i className="ri-time-line mr-2"></i>周一至周日 9:00-22:00</p>
              </div>
            </div>
          </div>

          <div className="border-t border-foreground-800 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
            <p className="text-xs text-foreground-500">
              &copy; {siteInfo.year} 丫丫影院 - 本站所有资源均来自互联网，仅供网友学习交流
            </p>
            <div className="flex items-center gap-4">
              <a href="#" className="text-xs text-foreground-500 hover:text-primary-400 transition-colors cursor-pointer" rel="nofollow">隐私政策</a>
              <a href="#" className="text-xs text-foreground-500 hover:text-primary-400 transition-colors cursor-pointer" rel="nofollow">服务条款</a>
              <a href="#" className="text-xs text-foreground-500 hover:text-primary-400 transition-colors cursor-pointer" rel="nofollow">免责声明</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}